import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const STEPS = [
    { id: 1, title: "Validation Commande", duration: 0, icon: "🤝", desc: "Signature et acompte" },
    { id: 2, title: "Brief Créatif", duration: 2, icon: "🎨", desc: "Définition de vos goûts" },
    { id: 3, title: "Maquettes & Design", duration: 5, icon: "✨", desc: "Création de l'identité visuelle" },
    { id: 4, title: "Développement", duration: 10, icon: "💻", desc: "Intégration et fonctionnalités" },
    { id: 5, title: "Recette & Contenus", duration: 3, icon: "📝", desc: "Corrections et textes" },
    { id: 6, title: "Mise en Ligne", duration: 1, icon: "🚀", desc: "Lancement officiel !" },
];

export default function CommercialRoadmapPage() {
    const navigate = useNavigate();
    const [startDate, setStartDate] = useState(new Date().toISOString().split('T')[0]);
    const [speed, setSpeed] = useState('standard'); // 'standard' or 'express'
    const [roadmap, setRoadmap] = useState([]);

    useEffect(() => {
        calculateRoadmap();
    }, [startDate, speed]);

    const calculateRoadmap = () => {
        let current = new Date(startDate);
        const multiplier = speed === 'express' ? 0.6 : 1; // Express is 40% faster

        const newRoadmap = STEPS.map((step, index) => {
            const daysToAdd = Math.ceil(step.duration * multiplier);
            current.setDate(current.getDate() + daysToAdd);

            // Skip weekends roughly (simplified)
            if (current.getDay() === 0) current.setDate(current.getDate() + 1);
            if (current.getDay() === 6) current.setDate(current.getDate() + 2);

            return {
                ...step,
                date: new Date(current),
                days: daysToAdd
            };
        });
        setRoadmap(newRoadmap);
    };

    const formatDate = (date) => {
        return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
    };

    const getTotalDays = () => {
        if (roadmap.length === 0) return 0;
        const start = new Date(startDate);
        const end = roadmap[roadmap.length - 1].date;
        const diffTime = Math.abs(end - start);
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    };

    return (
        <div style={{ height: '100vh', width: '100vw', background: '#f8fafc', color: '#1e293b', fontFamily: 'Inter, sans-serif', display: 'flex', flexDirection: 'column' }}>

            {/* Header */}
            <div style={{ padding: '30px 50px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'white', boxShadow: '0 4px 20px -10px rgba(0,0,0,0.05)' }}>
                <div>
                    <h1 style={{ margin: 0, fontSize: '1.8rem', fontWeight: 800, display: 'flex', alignItems: 'center', gap: 10 }}>
                        <span style={{ fontSize: '2rem' }}>🗓️</span> Roadmap Projet
                    </h1>
                    <p style={{ margin: '5px 0 0 0', opacity: 0.6 }}>Planification prévisionnelle</p>
                </div>

                <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <label style={{ fontSize: '0.8rem', fontWeight: 600, color: '#64748b' }}>Démarrage</label>
                        <input
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #cbd5e1', fontSize: '1rem', fontFamily: 'inherit' }}
                        />
                    </div>

                    <div style={{ background: '#f1f5f9', padding: 4, borderRadius: 8, display: 'flex' }}>
                        <button
                            onClick={() => setSpeed('standard')}
                            style={{ padding: '8px 16px', borderRadius: 6, border: 'none', background: speed === 'standard' ? 'white' : 'transparent', boxShadow: speed === 'standard' ? '0 2px 5px rgba(0,0,0,0.05)' : 'none', cursor: 'pointer', fontWeight: 600, transition: 'all 0.2s' }}
                        >
                            Standard
                        </button>
                        <button
                            onClick={() => setSpeed('express')}
                            style={{ padding: '8px 16px', borderRadius: 6, border: 'none', background: speed === 'express' ? '#ef4444' : 'transparent', color: speed === 'express' ? 'white' : 'inherit', boxShadow: speed === 'express' ? '0 2px 5px rgba(239, 68, 68, 0.3)' : 'none', cursor: 'pointer', fontWeight: 600, transition: 'all 0.2s' }}
                        >
                            Express ⚡
                        </button>
                    </div>
                </div>
            </div>

            {/* Timeline Area */}
            <div style={{ flex: 1, padding: 50, overflowX: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', position: 'relative', width: '100%', maxWidth: 1200 }}>

                    {/* Connecting Line */}
                    <div style={{ position: 'absolute', top: 55, left: 40, right: 40, height: 4, background: '#e2e8f0', borderRadius: 4, zIndex: 0 }} />
                    <div style={{
                        position: 'absolute', top: 55, left: 40, height: 4, background: '#3b82f6', borderRadius: 4, zIndex: 0,
                        width: '0%', animation: 'fillLine 1s ease-out forwards 0.5s', maxWidth: 'calc(100% - 80px)'
                    }} />

                    {roadmap.map((step, idx) => (
                        <div key={step.id} style={{ flex: 1, position: 'relative', zIndex: 1, textAlign: 'center', animation: `fadeInUp 0.5s ease-out ${idx * 0.2}s forwards`, opacity: 0, transform: 'translateY(20px)' }}>

                            {/* Icon Bubble */}
                            <div style={{
                                width: 70, height: 70, borderRadius: '24px', background: 'white',
                                border: '4px solid white', boxShadow: '0 10px 25px -5px rgba(59, 130, 246, 0.2)',
                                margin: '20px auto', display: 'grid', placeItems: 'center', fontSize: '2rem',
                                position: 'relative'
                            }}>
                                {step.icon}
                                <div style={{
                                    position: 'absolute', top: -15, right: -15, background: '#3b82f6', color: 'white',
                                    fontSize: '0.8rem', fontWeight: 700, padding: '4px 8px', borderRadius: 10
                                }}>
                                    {formatDate(step.date)}
                                </div>
                            </div>

                            {/* Content */}
                            <h3 style={{ fontSize: '1.2rem', fontWeight: 700, color: '#1e293b', margin: '0 0 5px 0' }}>{step.title}</h3>
                            <p style={{ fontSize: '0.9rem', color: '#64748b', margin: 0 }}>{step.desc}</p>

                            {/* Duration pill */}
                            <div style={{ marginTop: 10, display: 'inline-block', fontSize: '0.75rem', fontWeight: 600, color: '#94a3b8', background: '#f1f5f9', padding: '2px 8px', borderRadius: 4 }}>
                                +{step.days}j
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Footer Summary */}
            <div style={{ background: '#1e293b', color: 'white', padding: 30, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', gap: 40 }}>
                    <div>
                        <div style={{ fontSize: '0.9rem', opacity: 0.6 }}>Durée Totale</div>
                        <div style={{ fontSize: '1.5rem', fontWeight: 700 }}>{getTotalDays()} Jours</div>
                    </div>
                    <div>
                        <div style={{ fontSize: '0.9rem', opacity: 0.6 }}>Date de lancement</div>
                        <div style={{ fontSize: '1.5rem', fontWeight: 700, color: '#4ade80' }}>
                            {roadmap.length > 0 && roadmap[roadmap.length - 1].date.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
                        </div>
                    </div>
                </div>

                <div style={{ display: 'flex', gap: 20 }}>
                    <button onClick={() => navigate('/commercial/launchpad')} style={{ padding: '15px 30px', borderRadius: 50, border: '1px solid rgba(255,255,255,0.2)', background: 'transparent', color: 'white', fontSize: '1rem', cursor: 'pointer' }}>Retour</button>
                    <button onClick={() => alert('Planning envoyé par email au client !')} style={{ padding: '15px 30px', borderRadius: 50, border: 'none', background: 'white', color: '#1e293b', fontSize: '1rem', fontWeight: 700, cursor: 'pointer' }}>Envoyer le Planning 📧</button>
                </div>
            </div>

            <style>{`
                @keyframes fadeInUp { to { opacity: 1; transform: translateY(0); } }
                @keyframes fillLine { to { width: 100%; } }
            `}</style>
        </div>
    );
}
